(function() {
  var hubs = document.querySelectorAll('[data-laws-hub]');
  if (!hubs.length) return;

  hubs.forEach(function(root) {
    if (!root) return;
    if (root.dataset.hubInit === 'true') return;
    root.dataset.hubInit = 'true';

    var dataNode = root.querySelector('[data-hub-state-json]');
    if (!dataNode) return;

    var states;
    try {
      states = JSON.parse(dataNode.textContent);
    } catch (error) {
      return;
    }

    if (!states || !states.length) return;

    var mapAssetUrl = root.getAttribute('data-map-asset');
    var mapNode = root.querySelector('[data-hub-map]');
    var searchInput = root.querySelector('[data-hub-search]');
    var stateSelect = root.querySelector('[data-hub-state-select]');
    var statusNode = root.querySelector('[data-hub-filter-status]');
    var openButton = root.querySelector('[data-hub-open-state]');
    var nameNode = root.querySelector('[data-hub-detail-name]');
    var codeNode = root.querySelector('[data-hub-detail-code]');
    var verifiedNode = root.querySelector('[data-hub-detail-verified]');
    var overviewNode = root.querySelector('[data-hub-detail-overview]');
    var rangeButtons = Array.prototype.slice.call(root.querySelectorAll('[data-range-filter]'));
    var hasRangeControls = rangeButtons.length > 0;
    var wrap = root.querySelector('[data-hub-directory]');
    var chips = wrap ? Array.prototype.slice.call(wrap.querySelectorAll('.ar-laws-hub__chip')) : [];
    var letterBlocks = wrap ? Array.prototype.slice.call(wrap.querySelectorAll('[data-letter-block]')) : [];
    var alphaLinks = root ? Array.prototype.slice.call(root.querySelectorAll('[data-alpha-letter]')) : [];
    var mapPaths = {};
    var selectedCode = '';
    var activeRange = 'all';
    var pinnedRange = false;

    var initialHash = window.location.hash || '';
    if (/^#hub-(map-title|directory-title|states|atlas-)/.test(initialHash)) {
      if (window.history && window.history.replaceState) {
        window.history.replaceState(null, '', window.location.pathname + window.location.search);
      }
      window.scrollTo(0, 0);
    }

    var zipToState = [
      [/^0[12]\d{3}|^03\d{3}|^04\d{3}/, 'MA'], [/^05\d{3}/, 'VT'], [/^06\d{3}/, 'CT'], [/^07\d{3}|^08\d{3}/, 'NJ'],
      [/^(10|11|12|13|14)\d{3}/, 'NY'], [/^(15|16|17|18|19)\d{3}/, 'PA'], [/^(20|21)\d{3}/, 'DC'], [/^(22|23|24)\d{3}/, 'MD'],
      [/^(25|26)\d{3}/, 'VA'], [/^(27|28|29)\d{3}/, 'NC'], [/^(30|31)\d{3}/, 'SC'], [/^(32|33|34)\d{3}/, 'GA'],
      [/^(35|36)\d{3}/, 'AL'], [/^(37|38)\d{3}/, 'TN'], [/^39\d{3}/, 'MS'], [/^(40|41|42)\d{3}/, 'KY'],
      [/^(43|44|45)\d{3}/, 'OH'], [/^(46|47|48)\d{3}/, 'IN'], [/^(49|50|51|52)\d{3}/, 'MI'], [/^(53|54|55)\d{3}/, 'WI'],
      [/^56\d{3}/, 'MN'], [/^(57|58|59)\d{3}/, 'IA'], [/^(60|61|62)\d{3}/, 'IL'], [/^(63|64|65)\d{3}/, 'MO'],
      [/^(66|67|68|69)\d{3}/, 'KS'], [/^(70|71)\d{3}/, 'LA'], [/^(72|73|74|75)\d{3}/, 'AR'], [/^(76|77|78|79)\d{3}/, 'TX'],
      [/^(80|81)\d{3}/, 'CO'], [/^82\d{3}/, 'WY'], [/^(83|84)\d{3}/, 'UT'], [/^(85|86)\d{3}/, 'AZ'],
      [/^(87|88)\d{3}/, 'NM'], [/^89\d{3}/, 'NV'], [/^(90|91|92|93|94|95|96)\d{3}/, 'CA'], [/^97\d{3}/, 'OR'],
      [/^(98|99)\d{3}/, 'WA'], [/^967\d{2}|^968\d{2}/, 'HI']
    ];

    function normalize(value) {
      return String(value || '').toLowerCase().trim();
    }

    function inferStateFromZip(zip) {
      var value = String(zip || '').replace(/\D/g, '').slice(0, 5);
      if (!/^\d{5}$/.test(value)) return '';
      for (var index = 0; index < zipToState.length; index += 1) {
        if (zipToState[index][0].test(value)) return zipToState[index][1];
      }
      return '';
    }

    function findState(code) {
      for (var index = 0; index < states.length; index += 1) {
        if (states[index].code === code) return states[index];
      }
      return states[0];
    }

    function findStateBySearch(query) {
      var needle = normalize(query);
      if (!needle) return null;
      for (var index = 0; index < states.length; index += 1) {
        var state = states[index];
        if (normalize(state.code) === needle || normalize(state.name) === needle) return state;
      }
      for (var second = 0; second < states.length; second += 1) {
        var candidate = states[second];
        if (normalize(candidate.name).indexOf(needle) === 0) return candidate;
      }
      return null;
    }

    function rangeForLetter(letter) {
      var upper = String(letter || '').slice(0, 1).toUpperCase();
      if ('ABCDEFG'.indexOf(upper) !== -1) return 'ag';
      if ('HIJKLMN'.indexOf(upper) !== -1) return 'hn';
      if ('OPQRSTUVWXYZ'.indexOf(upper) !== -1) return 'oz';
      return 'all';
    }

    function rangeMatchesLetter(letter) {
      if (!hasRangeControls) return true;
      if (activeRange === 'all') return true;
      return rangeForLetter(letter) === activeRange;
    }

    function updateRangeButtons() {
      if (!hasRangeControls) return;
      rangeButtons.forEach(function(button) {
        var isActive = button.getAttribute('data-range-filter') === activeRange;
        button.classList.toggle('ar-laws-hub__segment-btn--active', isActive);
        button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      });
    }

    function toneStyles(selected) {
      return {
        fill: selected ? 'rgba(250, 208, 44, 0.3)' : 'rgba(21, 21, 21, 0.06)',
        stroke: selected ? 'rgba(250, 208, 44, 1)' : 'rgba(21, 21, 21, 0.18)',
        strokeWidth: selected ? 1.8 : 0.9
      };
    }

    function updateMapSelection(state) {
      Object.keys(mapPaths).forEach(function(code) {
        var path = mapPaths[code];
        var styles = toneStyles(code === state.code);
        path.setAttribute('fill', styles.fill);
        path.setAttribute('stroke', styles.stroke);
        path.setAttribute('stroke-width', String(styles.strokeWidth));
      });
    }

    function updateChipSelection(code, options) {
      options = options || {};
      var selectedChip = null;
      chips.forEach(function(chip) {
        var isSelected = chip.getAttribute('data-code') === code;
        chip.classList.toggle('ar-laws-hub__chip--selected', isSelected);
        if (isSelected) selectedChip = chip;
      });
      if (selectedChip && options.forceScroll) {
        selectedChip.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'smooth' });
      }
    }

    function renderState(code, options) {
      options = options || {};
      var state = findState(code);
      if (!state) return;

      selectedCode = state.code;
      if (stateSelect) stateSelect.value = state.code;
      if (nameNode) nameNode.textContent = state.name;
      if (codeNode) {
        codeNode.hidden = false;
        codeNode.textContent = '(' + state.code + ')';
      }
      if (verifiedNode) {
        if (state.verified) {
          verifiedNode.hidden = false;
          verifiedNode.textContent = 'Verified ' + state.verified;
        } else {
          verifiedNode.hidden = true;
          verifiedNode.textContent = '';
        }
      }
      if (overviewNode) {
        overviewNode.textContent = state.summary || ('Open the ' + state.name + ' page for current license, helmet, class, speed, access, and city-guide details.');
      }
      if (openButton) {
        openButton.href = state.url || '#';
        openButton.textContent = 'Open ' + state.name + ' law page';
      }
      if (hasRangeControls && !pinnedRange && !(searchInput && normalize(searchInput.value))) {
        activeRange = rangeForLetter(state.name);
        updateRangeButtons();
      }
      if (!options.skipDirectorySync) {
        filterDirectory();
      }
      updateMapSelection(state);
      updateChipSelection(state.code, { forceScroll: !!options.forceAtlasScroll && !options.skipAtlasScroll });
    }

    function updateStatus(visibleCount) {
      if (!statusNode) return;
      if (!hasRangeControls) {
        statusNode.textContent = 'Showing ' + visibleCount + ' state law pages.';
        statusNode.setAttribute('aria-label', statusNode.textContent);
        return;
      }
      if (visibleCount === states.length && activeRange === 'all') {
        statusNode.textContent = 'Showing all ' + states.length + ' state law pages.';
      } else if (activeRange !== 'all' && !(searchInput && normalize(searchInput.value))) {
        var rangeLabel = activeRange === 'ag' ? 'A–G' : activeRange === 'hn' ? 'H–N' : 'O–Z';
        statusNode.textContent = 'Showing ' + visibleCount + ' state law pages in ' + rangeLabel + '.';
      } else {
        statusNode.textContent = 'Showing ' + visibleCount + ' of ' + states.length + ' state law pages.';
      }
      statusNode.setAttribute('aria-label', statusNode.textContent);
    }

    function filterDirectory() {
      if (!chips.length) return;
      var query = normalize(searchInput && searchInput.value);
      var visibleCount = 0;

      chips.forEach(function(chip) {
        var name = normalize(chip.getAttribute('data-name'));
        var code = normalize(chip.getAttribute('data-code'));
        var letter = chip.getAttribute('data-letter') || '';
        var matchesQuery = !query || name.indexOf(query) !== -1 || code.indexOf(query) !== -1;
        var matchesRange = query ? true : rangeMatchesLetter(letter);
        var visible = matchesQuery && matchesRange;
        chip.hidden = !visible;
        if (visible) visibleCount += 1;
      });

      letterBlocks.forEach(function(block) {
        var hasVisible = !!block.querySelector('.ar-laws-hub__chip:not([hidden])');
        block.hidden = !hasVisible;
      });

      alphaLinks.forEach(function(link) {
        var letter = link.getAttribute('data-alpha-letter') || '';
        var block = wrap ? wrap.querySelector('[data-letter-block="' + letter + '"]') : null;
        link.hidden = !block || block.hidden;
      });

      updateStatus(visibleCount);

      var directMatch = findStateBySearch(query);
      if (directMatch && directMatch.code !== selectedCode) {
        renderState(directMatch.code, { skipDirectorySync: true, skipAtlasScroll: true });
      }
    }

    function renderMap(asset) {
      if (!mapNode || !asset || !asset.paths) return;

      mapNode.innerHTML = '';
      var svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
      svg.setAttribute('viewBox', '0 0 ' + asset.width + ' ' + asset.height);
      svg.setAttribute('role', 'img');
      svg.setAttribute('aria-label', 'United States state law map');

      Object.keys(asset.paths).forEach(function(code) {
        var state = findState(code);
        if (!state) return;

        var styles = toneStyles(code === selectedCode);
        var path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
        path.setAttribute('d', asset.paths[code]);
        path.setAttribute('fill', styles.fill);
        path.setAttribute('stroke', styles.stroke);
        path.setAttribute('stroke-width', String(styles.strokeWidth));
        path.setAttribute('vector-effect', 'non-scaling-stroke');
        path.setAttribute('tabindex', '0');
        path.setAttribute('role', 'button');
        path.setAttribute('aria-label', 'Select ' + state.name);
        path.setAttribute('class', 'is-interactive');
        path.dataset.code = code;
        path.addEventListener('click', function() {
          renderState(code, { skipAtlasScroll: true });
        });
        path.addEventListener('keydown', function(event) {
          if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            renderState(code, { skipAtlasScroll: true });
          }
        });
        mapPaths[code] = path;
        svg.appendChild(path);
      });

      mapNode.appendChild(svg);
      updateMapSelection(findState(selectedCode));
    }

    if (stateSelect) {
      stateSelect.addEventListener('change', function() {
        renderState(stateSelect.value, { skipAtlasScroll: true });
      });
    }

    if (searchInput) {
      searchInput.addEventListener('input', filterDirectory, { passive: true });
    }

    rangeButtons.forEach(function(button) {
      button.addEventListener('click', function() {
        activeRange = button.getAttribute('data-range-filter') || 'all';
        pinnedRange = true;
        updateRangeButtons();
        filterDirectory();
      });
    });

    chips.forEach(function(chip) {
      chip.addEventListener('mouseenter', function() {
        renderState(chip.getAttribute('data-code'), { skipAtlasScroll: true });
      });
      chip.addEventListener('focus', function() {
        renderState(chip.getAttribute('data-code'), { skipAtlasScroll: true });
      });
    });

    var params = new URLSearchParams(window.location.search || '');
    var queryState = String(params.get('state') || '').trim().toUpperCase();
    var zipState = inferStateFromZip(params.get('zip') || '');
    selectedCode = queryState || zipState || (stateSelect ? stateSelect.value : '') || states[0].code;
    updateRangeButtons();

    if (mapAssetUrl) {
      fetch(mapAssetUrl)
        .then(function(response) {
          if (!response.ok) throw new Error('map asset failed');
          return response.json();
        })
        .then(renderMap)
        .catch(function() {
          if (mapNode) {
            mapNode.innerHTML = '<p class="ar-laws-hub__map-loading">Map preview unavailable right now. Use the picker below.</p>';
          }
        });
    }

    renderState(selectedCode, { skipAtlasScroll: true });
    filterDirectory();
  });
})();
